import {
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
} from '@modeso/types__aumico-lib-annualreport-be';

export interface IAssignAccountEvent {
    item: IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI;
    parentGroup: IAccountMappingTemplateGroup;
    parent?: IAccountMappingTemplateGroupItemFLI;
}
